import { nextTick } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import routes from '@/router/routes';

/**
 * Vue Router 4 setup for the admin SPA.
 * Guard: meta.public routes are open; everything else requires a truthy Vuex token.
 */
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    next();
  } else if (store.getters.authenticated) {
    next();
  } else {
    next('/login');
  }
});

router.afterEach((to) => {
  nextTick(() => {
    document.title = to.meta.title ? to.meta.title + ' | Webwalker Admin' : 'Webwalker Admin';
  });
});

export default router;
